// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
  --mdc-switch-selected-handle-color: var(--primary-color);
  --mdc-switch-selected-hover-handle-color: var(--primary-color);
  --mdc-switch-selected-focus-handle-color: var(--primary-color);
  --mdc-switch-selected-pressed-handle-color: var(--primary-color);
  --mdc-switch-selected-track-color: color-mix(in srgb, var(--primary-color) 40%, white);
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 4px 24px 18px;
  border-bottom: 1px solid #edf1f6;
}
.dialog-header h2 {
  margin: 0;
  padding: 0;
  color: #253750;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
}
.dialog-header p {
  margin: 5px 0 0;
  color: #7d8a9d;
  font-size: 12px;
  line-height: 18px;
}

.icon-button {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #7d8a9d;
  cursor: pointer;
}
.icon-button .material-symbols-outlined {
  font-size: 20px;
}
.icon-button:hover:not(:disabled) {
  background: color-mix(in srgb, var(--primary-color) 6%, white);
  color: var(--primary-color);
}
.icon-button:disabled {
  cursor: default;
  opacity: 0.45;
}

.dialog-content {
  margin: 0;
  padding: 20px 24px;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.toggle-row strong {
  color: #35445b;
  font-size: 12px;
  font-weight: 600;
}
.toggle-row p {
  max-width: 330px;
  margin: 4px 0 0;
  color: #7d8a9d;
  font-size: 11px;
  line-height: 17px;
}

.saving {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 16px;
  color: #7d8a9d;
  font-size: 11px;
}

.confirmation {
  text-align: center;
}

.success-icon {
  color: #36866a;
  font-size: 42px;
}

.confirmation h3 {
  margin: 10px 0 4px;
  color: #253750;
  font-size: 15px;
  font-weight: 600;
}

.confirmation p {
  margin: 0;
  color: #7d8a9d;
  font-size: 12px;
  line-height: 18px;
}

.dialog-footer {
  min-height: 0;
  margin: 0;
  padding: 16px 24px;
  border-top: 1px solid #edf1f6;
}

.button {
  min-height: 34px;
  border: 1px solid var(--primary-color);
  border-radius: 7px;
  padding: 7px 14px;
  background: var(--primary-color);
  color: #fff;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

@media (max-width: 550px) {
  .dialog-header,
  .dialog-content,
  .dialog-footer {
    padding-inline: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/two-fa-toggle/two-fa-toggle.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,wDAAA;EACA,8DAAA;EACA,8DAAA;EACA,gEAAA;EACA,sFAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;EACA,gCAAA;AACJ;AACI;EACI,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACR;AAEI;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAAR;;AAIA;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AADJ;AAGI;EACI,eAAA;AADR;AAII;EACI,8DAAA;EACA,2BAAA;AAFR;AAKI;EACI,eAAA;EACA,aAAA;AAHR;;AAOA;EACI,SAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAJJ;AAMI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AAJR;AAOI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AALR;;AASA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AANJ;;AASA;EACI,kBAAA;AANJ;;AASA;EACI,cAAA;EACA,eAAA;AANJ;;AASA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANJ;;AASA;EACI,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AANJ;;AASA;EACI,aAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;AANJ;;AASA;EACI,gBAAA;EACA,sCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AANJ;;AASA;EAEI;;;IAGI,oBAAA;EAPN;AACF","sourcesContent":[":host {\n    display: block;\n    color: #253750;\n    font-size: 12px;\n    --mdc-switch-selected-handle-color: var(--primary-color);\n    --mdc-switch-selected-hover-handle-color: var(--primary-color);\n    --mdc-switch-selected-focus-handle-color: var(--primary-color);\n    --mdc-switch-selected-pressed-handle-color: var(--primary-color);\n    --mdc-switch-selected-track-color: color-mix(in srgb, var(--primary-color) 40%, white);\n}\n\n.dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 4px 24px 18px;\n    border-bottom: 1px solid #edf1f6;\n\n    h2 {\n        margin: 0;\n        padding: 0;\n        color: #253750;\n        font-size: 17px;\n        font-weight: 600;\n        line-height: 24px;\n    }\n\n    p {\n        margin: 5px 0 0;\n        color: #7d8a9d;\n        font-size: 12px;\n        line-height: 18px;\n    }\n}\n\n.icon-button {\n    display: grid;\n    flex: 0 0 auto;\n    place-items: center;\n    width: 28px;\n    height: 28px;\n    border: 0;\n    border-radius: 7px;\n    background: transparent;\n    color: #7d8a9d;\n    cursor: pointer;\n\n    .material-symbols-outlined {\n        font-size: 20px;\n    }\n\n    &:hover:not(:disabled) {\n        background: color-mix(in srgb, var(--primary-color) 6%, white);\n        color: var(--primary-color);\n    }\n\n    &:disabled {\n        cursor: default;\n        opacity: .45;\n    }\n}\n\n.dialog-content {\n    margin: 0;\n    padding: 20px 24px;\n}\n\n.toggle-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n\n    strong {\n        color: #35445b;\n        font-size: 12px;\n        font-weight: 600;\n    }\n\n    p {\n        max-width: 330px;\n        margin: 4px 0 0;\n        color: #7d8a9d;\n        font-size: 11px;\n        line-height: 17px;\n    }\n}\n\n.saving {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    margin-top: 16px;\n    color: #7d8a9d;\n    font-size: 11px;\n}\n\n.confirmation {\n    text-align: center;\n}\n\n.success-icon {\n    color: #36866a;\n    font-size: 42px;\n}\n\n.confirmation h3 {\n    margin: 10px 0 4px;\n    color: #253750;\n    font-size: 15px;\n    font-weight: 600;\n}\n\n.confirmation p {\n    margin: 0;\n    color: #7d8a9d;\n    font-size: 12px;\n    line-height: 18px;\n}\n\n.dialog-footer {\n    min-height: 0;\n    margin: 0;\n    padding: 16px 24px;\n    border-top: 1px solid #edf1f6;\n}\n\n.button {\n    min-height: 34px;\n    border: 1px solid var(--primary-color);\n    border-radius: 7px;\n    padding: 7px 14px;\n    background: var(--primary-color);\n    color: #fff;\n    font: inherit;\n    font-size: 12px;\n    cursor: pointer;\n}\n\n@media (max-width: 550px) {\n\n    .dialog-header,\n    .dialog-content,\n    .dialog-footer {\n        padding-inline: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
